import React, { useState } from "react";
import {
  Box, TextField, Typography, Card, CardContent, Snackbar, Alert, Button
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { vendorApi } from "../../api/api";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import GradientButton from "../common/GradiantButton";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../common/SecondaryButton";

const UpdatePrice = () => {
  const userId = useSelector((state) => state.user.userId);
  const theme = useSelector((data) => data.themeValue.colors);
  const location = useLocation();
  const navigate = useNavigate();
  const { propertyData } = location.state;
  const [price, setPrice] = useState(propertyData.price);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const handleUpdate = async () => {
    if (!price || isNaN(price) || Number(price) <= 0) {
      setSnackbar({
        open: true,
        message: "Please enter a valid SqFt price.",
        severity: "error",
      });
      return;
    }

    const formData = new FormData();
    formData.append("PropertyId", propertyData.PropertyId ?? propertyData[0]?.id);
    formData.append("UnitPrice", price);

    setLoading(true);

    try {
      const response = await vendorApi.updateVendorMarketPrice(formData);
      if (response && response.data) {
        setSnackbar({
          open: true,
          message: "Price updated successfully! 🎉",
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: "Failed to update price. Please try again.",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: `Error: ${error.message}`,
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: "auto", mt: 4, backgroundColor: theme.background, borderRadius: "10px" }}>
      <Card elevation={3} sx={{ backgroundColor: theme.background, borderRadius: "10px" }}>
        <CardContent>
          <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: theme.text }}>
            {propertyData.PropertyName ?? propertyData[0]?.PropertyName}
          </Typography>
          <Box display="flex" alignItems="center" mb={2}>
            <LocationOnIcon color="action" sx={{ mr: 1, color: theme.normal_icon }} />
            <Box>
              <Typography variant="body1" sx={{ color: theme.text }}>
                {propertyData.Address ?? propertyData[0]?.Address}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ color: theme.text }}>
                {propertyData.City ?? propertyData[0]?.City}
              </Typography>
            </Box>
          </Box>
          <Box mb={2}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ color: theme.text }}>
              Total Price:
            </Typography>
            <Typography variant="h6" sx={{ color: theme.text }}>
              ₹{propertyData.MarketPrice ?? propertyData[0]?.MarketPrice}
            </Typography>
          </Box>
          <Box mb={2}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ color: theme.text }}>
              SqFt Price:
            </Typography>
            <Typography variant="h6" sx={{ color: theme.text }}>
              ₹{propertyData.SqFtPrice ?? propertyData[0]?.SqFtPrice}
            </Typography>
          </Box>
          <TextField
            fullWidth
            label="Enter New SqFt Price"
            variant="outlined"
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
           sx={{
              mb: 3,
              input: {
                color: theme.text, 
              },
              label: {
                color: theme.text,
              },
              '& label.Mui-focused': {
                color: theme.primary_color, 
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.text, 
                },
                '&:hover fieldset': {
                  borderColor: theme.primary_color, 
                },
                '&.Mui-focused fieldset': {
                  borderColor: theme.primary_color, 
                },
              },
            }}
          />
          <Box display="flex" flexDirection="row" justifyContent="flex-end" gap={2}>
            <GradientButton
              height={50}
              width="30%"
              text="Update Price"
              onClick={handleUpdate} />
            <SecondaryButton
              height={50}
              width="20%"
              text="Cancel"
              onClick={() => navigate(-1)}
            />
          </Box>

        </CardContent>
      </Card>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>

  );
};
export default UpdatePrice;